import styled from 'styled-components';

const StyledHeader = styled.div`
  background-color: ${(props) => props.theme.colors.grey.light};
  padding: 32px 0;
`;

export default StyledHeader;
